import React, { useMemo, useEffect, useState } from "react";
import { Label, FormFeedback, FormGroup } from "reactstrap";
import Select from "react-select";

import { getRegions } from "common/services/regions.service";
import { COUNTRY_LEVEL } from "common/constants";
import { normalize } from "common/lib/normalize";

const SelectCurrentNationality = ({
  validation,
  setLoading,
}: {
  validation: any;
  setLoading?: any;
}) => {
  const customSelectStyles = {
    control: (styles: any) => ({
      ...styles,
      borderColor:
        validation.touched?.currentNationality &&
        validation.errors?.currentNationality
          ? "red"
          : "#ced4da",
      "&:hover": {
        borderColor:
          validation.touched?.currentNationality &&
          validation.errors?.currentNationality
            ? "red"
            : "#ced4da",
      },
    }),
  };
  const [data, setData] = useState([]);

  useEffect(() => {
    setLoading(true);

    const fetchData = async () => {
      try {
        const response = await getRegions({
          filters: {
            level: COUNTRY_LEVEL,
          },
        });
        setData(normalize(response.data));
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, [setLoading]);

  const options = useMemo(() => {
    return data.map((el: any) => {
      return {
        value: el?.id,
        label: el?.name,
      };
    });
  }, [data]);

  return (
    <FormGroup>
      <Label htmlFor="currentNationality-field" className="form-label">
        Current Nationality
      </Label>
      <Select
        name="currentNationality"
        id="currentNationality"
        value={
          validation.values?.currentNationality?.value
            ? validation.values?.currentNationality
            : null
        }
        placeholder="Select current nationality"
        onChange={(value: any) => {
          validation.setFieldValue("currentNationality", value);
        }}
        options={options}
        onBlur={() => validation.setFieldTouched("currentNationality", true)}
        className={
          validation.touched?.currentNationality &&
          validation.errors?.currentNationality
            ? "is-invalid"
            : ""
        }
        styles={customSelectStyles}
        isClearable={true}
      />
      <FormFeedback>
        {validation.errors?.currentNationality?.value}
      </FormFeedback>
    </FormGroup>
  );
};

export default SelectCurrentNationality;
